module.exports = __webpack_public_path__ + "static/hero-fallback-f2b3698177c2c18e5c0bfe7630cc686a.jpg";